import { render, staticRenderFns } from "./RiwayatGedungBangunanPage.vue?vue&type=template&id=5271d328"
import script from "./RiwayatGedungBangunanPage.vue?vue&type=script&lang=js"
export * from "./RiwayatGedungBangunanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports